import {
  GET_STATISTICS,
  GET_STATISTICS_SUCCESS,
  GET_STATISTICS_CATEGORIES,
  GET_STATISTICS_CATEGORIES_SUCCESS,
  CLEAR_STATISTICS_REDUCER,
} from '../constants/ActionTypes';

export const getStatistics = (filters = {}, pagination = {}) => ({
  type: GET_STATISTICS,
  payload: { filters, pagination },
});

export const getStatisticsSuccess = (statistic, pageCount) => ({
  type: GET_STATISTICS_SUCCESS,
  payload: { statistic, pageCount },
});

export const getStatisticsCategories = () => ({
  type: GET_STATISTICS_CATEGORIES,
});

export const getStatisticsCategoriesSuccess = ({ categories }) => ({
  type: GET_STATISTICS_CATEGORIES_SUCCESS,
  payload: { categories },
});

export const clearStatisticsReducer = () => ({
  type: CLEAR_STATISTICS_REDUCER,
});
